module.exports = "<sq-home-screen-add-on-host class=\"flexRowContainer flexFill\"></sq-home-screen-add-on-host>\n";